import React from 'react';
import Head from 'next/head';

export default ({ children, title = '合伙大师' }) => (
  <div>
    <Head>
      <title>{title}</title>
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
    </Head>
    {/* <p>Hello World!</p> */}
    {children}
  </div>
);



// WEBPACK FOOTER //
// pages/index.js